import { useMutation } from 'react-query'
import localForage from 'localforage'

import { useGlobalState } from 'store/state'

import { loginAPI } from './api'

export const useUser = () => {
  const { user } = useGlobalState()

  const { mutate, isLoading, isSuccess, error } = useMutation(
    loginAPI,
    {
      onSuccess: async userData => {
        // The HTTP wrapper reads the token from localForage on every
        // request. The hookstate LocalForage plugin persists via a
        // fire-and-forget setItem, so a `user.set()` here can race the
        // next API call (which fires as soon as React re-renders into
        // the authed routes). In a clean-slate session (incognito, or
        // after localForage was cleared) the racing read returns null
        // and the very first authed request goes out with no token,
        // 401s, and the error handler bounces us back to login.
        //
        // Persist explicitly + await before flipping React state.
        const current =
          (await localForage.getItem('globalState')) || {}
        await localForage.setItem('globalState', {
          ...current,
          user: userData
        })
        user.set(userData)
      }
    }
  )

  return {
    login: mutate,
    isLoading,
    isSuccess,
    error
  }
}
